import Domen from '../../../stores/Domen';
import GlobalState, { 
    changesegmentationpagecenter1,
    changesegmentsheduleid,
 } from '../../../stores/GlobalState';

import { updateDataPortrait } from './UpdateDataPortrait';


export async function PostLinkOutlineBig(startDate, polden, setTextloadingcompleated) {
    changesegmentationpagecenter1(2);

    let h = GlobalState.sheduleHour;
    if (polden === 2) {
        if(h<12)
        {
            h = h*1+12;
        }
        else
        {
            h = "00";
        }
    }
    if (h < 10) {
        h = "0" + h;
    }

    const d = new Date(startDate);
    let y = d.getFullYear();
    let m = d.getMonth() + 1;
    let a = d.getDate();

    if (m < 10) m = "0" + m;
    if (a < 10) a = "0" + a;

    let minutes = GlobalState.sheduleMinute * 1;
    if (minutes < 10) minutes = "0" + minutes;

    const timestamp = `${y}-${m}-${a}T${h}:${minutes}:00.682Z`;

    const token = localStorage.getItem("token");
    const product = {
        table: GlobalState.portraitsheduledeployname,
        credentials: GlobalState.portraitsheduledeploycred,
        startTime: timestamp,
        periodicity: GlobalState.sheduleEvery.value
    };

    console.log(product);
    setTextloadingcompleated('Processing the saving of deployment');

    const response = await fetch(Domen.url + `portraits/table/deploy/bigquery/schedule`, {
        method: 'POST',
        headers: {
            'Authorization': token,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(product),
    });

    if (response.status >= 200 && response.status < 400) {
        const data = await response.json();
        console.log(JSON.stringify(data.deployment_id) + " test");
        changesegmentsheduleid(data.deployment_id);
        changesegmentationpagecenter1(3);
        updateDataPortrait();

        setTimeout(() => {
            changesegmentationpagecenter1(4);
        }, 2000);
    } else {
        changesegmentationpagecenter1(5);
        setTimeout(() => {
            changesegmentationpagecenter1(1);
        }, 2000);
    }
}
